<vg-maintenance *ngIf="maintenance"></vg-maintenance>
<router-outlet *ngIf="!maintenance"></router-outlet>
<vg-modal-sso-error *ngIf="isOpenModal"></vg-modal-sso-error>
